import { hasCapability, type User } from "../base";

export const homeownerPortal = {
  read: (user: User) => hasCapability(user, "homeownerPortal.read"),
};
